// @flow

import React, { type ElementProps } from "react";
import { ObjectFieldTemplateProps } from "react-jsonschema-form";

type Props = ElementProps<typeof ObjectFieldTemplateProps>;

const ObjectTemplate = (props: Props) => {
  return (
    <div className="fc-schema-form-obj">
      {props.properties.map((element, index) => (
        <div className="property-wrapper" key={index}>
          {element.content}
        </div>
      ))}
    </div>
  );
};

export default ObjectTemplate;
